var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import { Body } from './components/Body';
import { Content } from './components/Content';
import { Header } from './components/Header';
import { Item } from './components/Item';
import { Price } from './components/Price';
import { Subtitle } from './components/Subtitle';
import { Title } from './components/Title';
import { StyledAccordion } from './styles/accordion.styled';
const Accordion = forwardRef(function AccordionWithForwardRef(_a, ref) {
    var { forceMobileView = false, children } = _a, props = __rest(_a, ["forceMobileView", "children"]);
    return (_jsx(StyledAccordion, Object.assign({ "$isResponsive": !forceMobileView, ref: ref }, props, { children: children })));
});
Accordion.Header = Header;
Accordion.Content = Content;
Accordion.Item = Item;
Accordion.Title = Title;
Accordion.Subtitle = Subtitle;
Accordion.Price = Price;
Accordion.Body = Body;
export { Accordion };
